<template>
  <div>
    <div class="nav-body">
      <!-- 侧边导航 -->

      <div class="nav-side" ref="navSide">
        <ul>
          <li
            v-for="(item,index) in categories"
            :key="item.id"
            @mouseenter="showDetail(index)"
            @mouseleave="hideDetail(index)"
            :class="[activeIndex==index?'active':'']"
          >
            <span class="nav-side-item">{{item.name}}</span>

            <div class="detail-item-panel panel-1">
              <ul>
                <li class="detail-item-row">
                  <!-- <h5 class="detail-item-title">{{items.title}}</h5> -->
                  <router-link
                    v-for="(items, index) in item.children"
                    :key="index"
                    :to="{path:'/onlineclass',query:{id:items.id,pid:item.id}}"
                  >
                    <span class="detail-item">{{items.name}}</span>
                    <em>|</em>
                  </router-link>
                </li>
              </ul>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "HomeNav",
  data() {
    return {
      isload: false,
      activeIndex: 188,
      panel1: false,
      panel2: false,
      categories: [],
      CarouselItems: [
        {
          children: [],
        },
      ],
    };
  },
  computed: {
    // ...mapState(["marketing"])
  },

  created() {
    this.$http({
      url: "/api/v1/categories/all",
      method: "get",
    }).then((res) => {
      if (res.status == 200) {
        this.categories = res.data.categories;
        this.isload = true;
      }
    });
  },
  methods: {
    showDetail(index) {
      this.activeIndex = index;
      this.panel1 = true;
    },
    hideDetail(index) {
      this.activeIndex =188;
      this.panel1 = false;
    },
  },
  mounted() {
    // this.$refs.itemPanel1.style.left =
    //   this.$refs.navSide.offsetLeft + this.$refs.navSide.offsetWidth + "px";
    // this.$refs.itemPanel1.style.top = this.$refs.navSide.offsetTop + "px";
  },
  updated() {
    // this.$refs.itemPanel1.style.left =
    //   this.$refs.navSide.offsetLeft + this.$refs.navSide.offsetWidth + "px";
    // this.$refs.itemPanel1.style.top = this.$refs.navSide.offsetTop + "px";
  },
};
</script>

<style scoped lang='less'>
/*大的导航信息，包含导航，幻灯片等*/
.nav-body {
  height: 380px;
  margin: 0px auto;
}
.nav-side {
  width: 200px;
  height: 100%;
  padding: 0px;
  color: #fff;
  float: left;
  background-color: rgba(0, 0, 0, 0.40);
}
.nav-side ul {
  width: 100%;
  padding: 0px;
  list-style: none;
  position: relative;
}
.nav-side li {
  padding-left: 7.5px;
  padding-left: 15px;
  font-size: 18px;
  height: 75px;
  line-height: 75px;
  cursor: pointer;

  &.active,
  &:hover {
    background: #fff;
    color: #e31436;
    .detail-item-panel {
      display: block;
    }
  }
}

/*导航内容*/
.nav-content {
  width: 792px;
  margin-left: 15px;
  overflow: hidden;
  float: left;
}
/*导航图片*/
.nav-show-img {
  margin-top: 10px;
  float: left;
}
.nav-show-img:nth-child(2) {
  margin-left: 12px;
}
/*显示商品*/
.content {
  width: 100%;
}
/*显示商品详细信息*/
.detail-item-panel {
  width: 587px;
  height: 380px;
  box-sizing: border-box;
  padding: 20px 40px 20px 0;
  background-color: #fff;
  position: absolute;
  top: 0;
  left: 200px;
  z-index: 999;
  display: none;
}
.nav-detail-item {
  margin-left: 26px;
  margin-top: 15px;
  margin-bottom: 15px;
  cursor: pointer;
  color: #eee;
}
.nav-detail-item span {
  padding: 6px;
  padding-left: 12px;
  margin-left: 15px;
  font-size: 12px;
  background-color: #6e6568;
}
.nav-detail-item span:hover {
  margin-left: 15px;
  background-color: #f44336;
}
.detail-item-panel ul {
  list-style: none;
}
.detail-item-panel li {
  line-height: 38px;
  margin-left: 40px;
}
.detail-item-title {
  padding-right: 6px;
  font-weight: bold;
  font-size: 12px;
  cursor: pointer;
  color: #555555;
}
.detail-item-title:hover {
  color: #d9534f;
}
.detail-item-row {
  display: flex;
  flex-wrap: wrap;
  em {
    color: #dadee8;
    padding: 0 14px;
    font-style: normal;
  }
  a:last-child {
    em {
      display: none;
    }
  }
}
.detail-item-row a {
  color: #555555;
}

.detail-item {
  font-size: 14px;
  padding-left: 8px;
  padding-right: 8px;
  cursor: pointer;
  // border-right: 1px solid #ccc;
}
.detail-span:last-child span {
  border-right: none;
}
.detail-item:hover {
  color: #d9534f;
}
</style>
